import axios from '../axios'

// モジュール更新
const putModuleApi = async (moduleId, payload) => {
  return await axios.put(`api/lms/modules/${moduleId}`, payload)
}

export default putModuleApi
